/*
 * Kremi değerlendirmeleri — kendi altyapı (Commerce App kararı 2026-08-31; 09-30 varyant + çok ürün).
 *
 * Her [data-kremi-reviews] kökü, içindeki <script type="application/json" data-kremi-reviews-config>
 * ayarıyla başlatılır (metinler Liquid'de çevrilip buraya gelir). İki bağlam:
 *   - product: ürün sayfası — tek ürün, JSON-LD burada; sayfadaki varyant seçimini izler.
 *   - page   : ör. Maskeler sayfası — birden çok ürünün yorumları tek listede (form/JSON-LD yok).
 *
 * Veri App Proxy → storefront-api (mobil uygulamayla AYNI kayıt):
 *   GET  /reviews/config                                   → { listVisible, … }
 *   GET  /reviews?handle=&limit=&before=&variant=          → { reviews: [...] }   (listVisible kapısı)
 *   GET  /reviews/summary?handle=                          → { summary: { rating, count, distribution? } }
 *
 * KAPI sunucudadır: blok YALNIZ listVisible açıkken görünür. FORM YOK (10-01): yorumlar e-posta davet
 * bağlantısıyla /pages/degerlendir'den yazılır (assets/kremi-review-invite.js).
 *
 * BOŞ DURUM (10-06): ürünün hiç yorumu yoksa blok GİZLİ kalır (09-18 "yorum 0 ise gözükmesin" kuralı;
 * sayfada yorum formu da yok, boş kutu müşteriye bir şey sunmaz). Özet ucu düşse bile liste doluysa
 * blok görünür (yalnız özetsiz). Seçenek süzgecinde boşluk → "Bu seçenek için henüz yok" metni.
 *
 * ROZET → LİSTE (10-06, denetim B9): ürün bilgisindeki puan rozeti href'siz <a data-kremi-rating-link>
 * basılır; liste görünür olunca burada href="#kremi-reviews" alır. Sayfa #kremi-reviews ile açıldıysa
 * blok JS'le görünür olduğu için tarayıcının ilk kaydırması boşa gider → görünür olunca kaydırılır.
 *
 * GİZLİLİK: yorumcu adı YALNIZ maskeli ("Ayşe Y.") gösterilir — sunucu maskDisplayName ile üretir, burada
 * savunma amaçlı yeniden kısaltılır (davet sayfasındaki aydınlatma satırıyla aynı söz, 10-06; mobil
 * uygulama da aynı alanı gösterir). "Doğrulanmış Alıcı" rozeti GÖSTERİLMEZ (Zeynep 10-01).
 * FOTOĞRAF: yalnız sunucunun `photos` alanı — moderasyonda yayına alınmış olanlar (bekleyen
 * pendingPhotos dışarı hiç çıkmaz); burada ayrıca yalnız https adresler çizilir.
 * Yorum metni kullanıcı girdisidir → DOM textContent ile kurulur, innerHTML YOK.
 */
(() => {
  const PAGE = 20;

  function init(root) {
    if (root.__kremiReviews) return;
    root.__kremiReviews = true;

    let cfg;
    try {
      cfg = JSON.parse(root.querySelector('script[data-kremi-reviews-config]').textContent);
    } catch (e) {
      return;
    }
    const products = (cfg.products || []).filter((p) => p && p.handle);
    if (!products.length) return;

    const S = cfg.strings || {};
    const BASE = (window.KREMI_WISHLIST_BASE || '/apps/kremi') + '/reviews';
    const isProduct = cfg.context === 'product';
    const $ = (sel) => root.querySelector(sel);

    const list = $('[data-list]');
    const more = $('[data-more]');
    const empty = $('[data-empty]');
    const chipsEl = $('[data-variants]');
    const summaryEl = $('[data-summary]');

    // Varyant kimliği → { title (bu dilde), handle } — kart etiketi de buradan (yorumdaki başlık
    // mağazanın varsayılan dilindedir; sayfada seçili dilin başlığı tercih edilir).
    // Seçim GRUPLARI varyant ADINA göre: Maskeler sayfasında tekli maske ve 5'li setin varyantları
    // aynı adı taşır ("Vitamin C Tone Up Serum Mask") — tek seçenek, iki ürünün o varyantını getirir.
    const variantIndex = {};
    const groups = {}; // anahtar → { label, members: [{ handle, id }] }
    const groupOrder = [];
    products.forEach((p) => {
      (p.variants || []).forEach((v) => {
        const id = String(v.id);
        const key = String(v.title || id).trim().toLowerCase();
        variantIndex[id] = { title: v.title, handle: p.handle, group: key };
        if (!groups[key]) {
          groups[key] = { label: v.title, members: [] };
          groupOrder.push(key);
        }
        groups[key].members.push({ handle: p.handle, id: id });
      });
    });

    let selectedGroup = null; // null = tümü
    let cursors = {}; // "handle|variant" → { before, done }
    let seen = Object.create(null);
    let loading = false;
    let requestSeq = 0; // yarışan istek kalkanı: yalnız EN SON istek çizilir
    const firstPageReviews = [];

    const pad = (n) => (n < 10 ? '0' : '') + n;
    const stars = (n) => '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
    const ratingLabel = (value) => (S.ratingInfo || '').replace('__RATING__', value).replace('__MAX__', 5);

    function pluralCategory(n) {
      try {
        return new Intl.PluralRules(cfg.locale).select(n);
      } catch (e) {
        return n === 1 ? 'one' : 'other';
      }
    }
    // Shopify'ın çoğullamasını JS'te üretemeyiz: 1/2/5 örnek gövdeleri Liquid'de alınır, gerçek
    // sayının kategorisine göre örnekteki rakam değiştirilir (ayrıntı: eski snippet notu, 09-03).
    function reviewCountLabel(n) {
      const c = pluralCategory(n);
      if (c === 'one') return (S.countOne || '').replace('1', String(n));
      if (c === 'few') return (S.countFew || '').replace('2', String(n));
      return (S.countMany || '').replace('5', String(n));
    }

    function formatDate(iso) {
      const d = new Date(iso);
      if (isNaN(d.getTime())) return String(iso).slice(0, 10);
      return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear();
    }

    /**
     * "Ayşe Yılmaz" → "Ayşe Y." (sunucudaki maskDisplayName ile aynı kural). Zaten maskeli ad
     * ("Ayşe Y.") olduğu gibi kalır; boş ad ve sunucunun anonim varsayılanı bu dildeki anonim
     * etikete çevrilir.
     */
    function maskName(raw) {
      const parts = String(raw || '').trim().split(/\s+/).filter(Boolean);
      if (!parts.length || parts.join(' ') === 'Kremi Müşterisi') return S.anonymousReviewer || '';
      if (parts.length === 1) return parts[0];
      // 10-08 Zeynep: tüm adlar yazılır, yalnız soyad maskelenir ("Ayşe Nur Y.") — sunucu
      // (@kremi/core formatReviewerName) ve uygulamayla aynı biçim.
      const last = parts[parts.length - 1];
      return parts.slice(0, -1).join(' ') + ' ' + last.charAt(0).toLocaleUpperCase('tr-TR') + '.';
    }

    const isHttpsUrl = (u) => typeof u === 'string' && /^https:\/\//i.test(u);

    function getJson(url) {
      return fetch(url, { headers: { Accept: 'application/json' } }).then((res) => {
        if (!res.ok) throw new Error(url + ' ' + res.status);
        return res.json();
      });
    }

    function el(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined && text !== null) node.textContent = text;
      return node;
    }

    // ── Kart ────────────────────────────────────────────────────────────────
    const photoModalImage = $('[data-photo-modal-image]');
    const photoModalTitle = $('[data-photo-modal-title]');

    function renderReview(r) {
      const item = el('article', 'kremi-reviews__item');

      const head = el('div', 'kremi-reviews__head');
      const st = el('span', 'kremi-reviews__stars-static', stars(r.rating));
      st.setAttribute('role', 'img');
      st.setAttribute('aria-label', ratingLabel(r.rating));
      head.appendChild(st);

      // Ad YALNIZ maskeli; "Doğrulanmış Alıcı" rozeti GÖSTERİLMEZ (Zeynep 10-01; başlık notu).
      const name = maskName(r.displayName);
      if (name) head.appendChild(el('span', 'kremi-reviews__name', name));

      if (r.featured) head.appendChild(el('span', 'kremi-reviews__featured', S.featured));

      if (r.createdAt) {
        const d = el('time', 'kremi-reviews__date', formatDate(r.createdAt));
        d.dateTime = r.createdAt;
        head.appendChild(d);
      }
      item.appendChild(head);

      const variantTitle =
        (r.variantId && variantIndex[String(r.variantId)] && variantIndex[String(r.variantId)].title) ||
        r.variantTitle;
      if (variantTitle) {
        const vl = el('p', 'kremi-reviews__variant');
        vl.appendChild(el('span', 'kremi-reviews__variant-key', S.variantLabel + ': '));
        vl.appendChild(el('span', null, variantTitle));
        item.appendChild(vl);
      }

      if (r.title) item.appendChild(el('p', 'kremi-reviews__item-title', r.title));
      item.appendChild(el('p', 'kremi-reviews__body', r.body || ''));

      const shownPhotos = (Array.isArray(r.photos) ? r.photos : []).filter((p) => p && isHttpsUrl(p.url));
      if (shownPhotos.length) {
        const photos = el('div', 'kremi-reviews__photos');
        shownPhotos.forEach((p, idx) => {
          const alt = S.photoAlt + ' ' + (idx + 1);
          const btn = el('button', 'kremi-reviews__photo');
          btn.type = 'button';
          btn.setAttribute('aria-controls', cfg.photoModalId);
          btn.setAttribute('aria-label', alt);
          const img = el('img');
          img.src = isHttpsUrl(p.thumbUrl) ? p.thumbUrl : p.url;
          img.alt = '';
          img.loading = 'lazy';
          img.decoding = 'async';
          btn.appendChild(img);
          // Modal açılışı theme.js DialogElement'in aria-controls delegesiyle (ekstra show() yok).
          btn.addEventListener('click', () => {
            if (photoModalImage) {
              photoModalImage.src = p.url;
              photoModalImage.alt = alt;
            }
            if (photoModalTitle) photoModalTitle.textContent = alt;
          });
          photos.appendChild(btn);
        });
        item.appendChild(photos);
      }

      if (r.reply && r.reply.body) {
        const reply = el('div', 'kremi-reviews__reply');
        const replyHead = el('p', 'kremi-reviews__reply-head');
        replyHead.appendChild(el('strong', null, S.replySignature));
        if (r.reply.at) {
          const rd = el('time', 'kremi-reviews__reply-date', formatDate(r.reply.at));
          rd.dateTime = r.reply.at;
          replyHead.appendChild(rd);
        }
        reply.appendChild(replyHead);
        reply.appendChild(el('p', 'kremi-reviews__reply-body', r.reply.body));
        item.appendChild(reply);
      }
      return item;
    }

    // ── Liste (çok ürün + varyant süzgeci) ─────────────────────────────────
    /** Sorgulanacak (ürün, varyant) çiftleri — seçim yoksa her ürün süzgeçsiz. */
    function targets() {
      if (selectedGroup) return groups[selectedGroup].members.map((m) => ({ handle: m.handle, variant: m.id }));
      return products.map((p) => ({ handle: p.handle, variant: null }));
    }
    const cursorKey = (t) => t.handle + '|' + (t.variant || '');

    function resetList() {
      list.textContent = '';
      seen = Object.create(null);
      cursors = {};
      more.hidden = true;
      if (empty) empty.hidden = true;
    }

    /** Bir sonraki sayfayı yükler; eklenen yorum sayısını döner. */
    function loadPage() {
      if (loading) return Promise.resolve(0);
      loading = true;
      more.disabled = true;
      const seq = ++requestSeq;
      const pending = targets().filter((t) => !(cursors[cursorKey(t)] && cursors[cursorKey(t)].done));

      return Promise.all(
        pending.map((t) => {
          const c = cursors[cursorKey(t)] || {};
          const url =
            BASE + '?handle=' + encodeURIComponent(t.handle) + '&limit=' + PAGE +
            (c.before ? '&before=' + encodeURIComponent(c.before) : '') +
            (t.variant ? '&variant=' + encodeURIComponent(t.variant) : '');
          return getJson(url).then((data) => ({ key: cursorKey(t), reviews: (data && data.reviews) || [] }));
        }),
      )
        .then((pages) => {
          if (seq !== requestSeq) return 0; // daha yeni bir istek geldi — bunu çizme
          let merged = [];
          pages.forEach((pg) => {
            const last = pg.reviews[pg.reviews.length - 1];
            cursors[pg.key] = { before: last ? last.createdAt : null, done: pg.reviews.length < PAGE };
            merged = merged.concat(pg.reviews);
          });
          // Öne çıkanlar önce, sonra en yeni (çok üründe sayfa içi birleştirme).
          merged.sort((a, b) => {
            if (!!b.featured !== !!a.featured) return b.featured ? 1 : -1;
            return String(b.createdAt).localeCompare(String(a.createdAt));
          });
          let added = 0;
          merged.forEach((r) => {
            if (!r || !r.id || seen[r.id]) return;
            seen[r.id] = true;
            // JSON-LD Review adayları: ürün sayfasında her yorum bu ürünündür (varyant süzgeci olsa da).
            if (firstPageReviews.length < 10 && (isProduct || !selectedGroup)) firstPageReviews.push(r);
            list.appendChild(renderReview(r));
            added++;
          });
          more.hidden = targets().every((t) => cursors[cursorKey(t)] && cursors[cursorKey(t)].done);
          if (empty) {
            // Süzgeçsiz boşluk (özet sayı verdi ama yayında metin yok) ≠ seçenek boşluğu.
            empty.textContent = selectedGroup ? S.noVariantReviews || empty.textContent : S.noReviews || '';
            empty.hidden = list.childElementCount > 0;
          }
          return added;
        })
        .finally(() => {
          loading = false;
          more.disabled = false;
        });
    }

    // ── Varyant seçimi ──────────────────────────────────────────────────────
    const chipButtons = {};
    function paintChips() {
      Object.keys(chipButtons).forEach((key) => {
        const on = (key === 'all' && !selectedGroup) || key === selectedGroup;
        chipButtons[key].classList.toggle('is-selected', on);
        chipButtons[key].setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    /**
     * @param {string|null} groupKey  null = tümü
     * @param {boolean} fallbackToAll  sayfadaki varyant seçimini izlerken: o varyantın yorumu yoksa
     *   liste boş kalmasın, "tümü"ne dön (elle seçimde boş liste + "henüz yok" mesajı gösterilir).
     */
    function selectGroup(groupKey, fallbackToAll) {
      const next = groupKey && groups[groupKey] ? groupKey : null;
      if (next === selectedGroup && list.childElementCount) return Promise.resolve();
      selectedGroup = next;
      paintChips();
      resetList();
      const showAll = () => {
        selectedGroup = null;
        paintChips();
        resetList();
        return loadPage();
      };
      return loadPage().then(
        (added) => {
          if (!added && fallbackToAll && selectedGroup) return showAll();
          return added;
        },
        (err) => {
          // Denetim tema-2 (10-07): seçenek isteği düştü (proxy 500/zaman aşımı). Liste resetList ile
          // boşaltılmıştı — sessizce boş kalmasın. Bu arada başka seçim yapıldıysa ona dokunma.
          if (selectedGroup !== next) return 0;
          if (fallbackToAll && selectedGroup) return showAll(); // sayfa seçimini izlerken: Tümü'ne dön
          if (selectedGroup) {
            showLoadError(); // elle seçilen çip: boş liste yerine hata metni
            return 0;
          }
          throw err; // Tümü de düştü → çağıran karar verir (ilk açılışta blok gizli kalır)
        },
      );
    }

    function showLoadError() {
      if (!empty || list.childElementCount) return;
      empty.textContent = S.error || empty.textContent;
      empty.hidden = false;
    }

    const groupOfVariant = (id) => (id && variantIndex[String(id)] ? variantIndex[String(id)].group : null);

    function buildChips() {
      if (!chipsEl || groupOrder.length < 2) return;
      const add = (key, label) => {
        const b = el('button', 'block-swatch kremi-reviews__variant-chip', label);
        b.type = 'button';
        b.addEventListener('click', () => selectGroup(key === 'all' ? null : key, false).catch(showLoadError));
        chipButtons[key] = b;
        chipsEl.appendChild(b);
      };
      add('all', S.allVariants);
      groupOrder.forEach((key) => add(key, groups[key].label));
      paintChips();
      chipsEl.hidden = false;
    }

    // ── Özet (çok üründe birleştirilir) ────────────────────────────────────
    function combineSummaries(summaries) {
      let count = 0;
      let weighted = 0;
      let distribution = {};
      let hasDistribution = true;
      summaries.forEach((s) => {
        if (!s || !s.count) return;
        count += s.count;
        weighted += Number(s.rating) * s.count;
        if (s.distribution && typeof s.distribution === 'object') {
          Object.keys(s.distribution).forEach((k) => {
            distribution[k] = (distribution[k] || 0) + (Number(s.distribution[k]) || 0);
          });
        } else {
          hasDistribution = false;
        }
      });
      if (!count) return null;
      return {
        rating: Math.round((weighted / count) * 10) / 10,
        count: count,
        ...(hasDistribution ? { distribution } : {}),
      };
    }

    function renderSummary(summary) {
      if (!summary || !summary.count) return;
      $('[data-summary-value]').textContent = Number(summary.rating).toFixed(1);
      const sStars = $('[data-summary-stars]');
      sStars.textContent = stars(Math.max(0, Math.min(5, Math.round(summary.rating))));
      sStars.setAttribute('aria-label', ratingLabel(Number(summary.rating).toFixed(1)));
      $('[data-summary-count]').textContent = reviewCountLabel(summary.count);

      const bars = $('[data-summary-bars]');
      if (summary.distribution) {
        const total = summary.count;
        [5, 4, 3, 2, 1].forEach((star) => {
          const count = Number(summary.distribution[String(star)]) || 0;
          const row = el('div', 'kremi-reviews__summary-bar');
          row.setAttribute('role', 'listitem');
          row.setAttribute('aria-label', (S.starCounts || {})[star] + ': ' + reviewCountLabel(count));
          row.appendChild(el('span', 'kremi-reviews__summary-bar-label', String(star)));
          const track = el('span', 'kremi-reviews__summary-bar-track');
          const fill = el('span', 'kremi-reviews__summary-bar-fill');
          fill.style.width = Math.round((count / total) * 100) + '%';
          track.appendChild(fill);
          row.appendChild(track);
          row.appendChild(el('span', 'kremi-reviews__summary-bar-count', String(count)));
          bars.appendChild(row);
        });
        bars.hidden = false;
      }
      summaryEl.hidden = false;
    }

    // ── JSON-LD (yalnız ürün sayfası; var olan Product şemasını zenginleştirir) ─
    // Puan (aggregateRating) 10-06'dan beri SUNUCUDA (snippets/microdata-schema.liquid, metafield).
    // Burada: puan yoksa özetle doldur (metafield senkronu gecikmişse), Review düğümleri yoksa ekle.
    // İkisi de idempotent — ikinci Product şeması AÇILMAZ, var olan alan EZİLMEZ.
    function injectStructuredData(summary, reviews) {
      if (!isProduct) return;
      const script = document.getElementById('kremi-product-schema');
      if (!script) return;
      let data;
      try {
        data = JSON.parse(script.textContent);
      } catch (e) {
        return;
      }
      // Varyantlı üründe kök tip ProductGroup (varyantlar hasVariant'ta) — ikisi de puan taşır (09-30).
      const isProductNode = (n) => n && (n['@type'] === 'Product' || n['@type'] === 'ProductGroup');
      let node = isProductNode(data) ? data : null;
      if (!node && data && Array.isArray(data['@graph'])) {
        node = data['@graph'].filter(isProductNode)[0];
      }
      if (!node) return;
      let changed = false;
      const hasRating = !!(node.aggregateRating && node.aggregateRating.reviewCount);
      if (!hasRating && summary && summary.count) {
        node.aggregateRating = {
          '@type': 'AggregateRating',
          ratingValue: summary.rating,
          reviewCount: summary.count,
          bestRating: 5,
          worstRating: 1,
        };
        changed = true;
      }
      // Review'ler puansız Product'ta geçersiz sayılır → puan yoksa ekleme.
      if (!node.aggregateRating || (Array.isArray(node.review) && node.review.length)) {
        if (changed) script.textContent = JSON.stringify(data);
        return;
      }
      const reviewNodes = (reviews || [])
        .filter((r) => r && r.body && r.rating)
        .slice(0, 10)
        .map((r) => {
          const n = {
            '@type': 'Review',
            reviewRating: { '@type': 'Rating', ratingValue: r.rating, bestRating: 5, worstRating: 1 },
            // Sayfadaki kartla AYNI (maskeli) ad — görünür içerikle tutarlı.
            author: { '@type': 'Person', name: maskName(r.displayName) || S.anonymousReviewer },
            reviewBody: r.body,
          };
          if (r.title) n.name = r.title;
          if (r.createdAt) n.datePublished = String(r.createdAt).slice(0, 10);
          return n;
        });
      if (reviewNodes.length) {
        node.review = reviewNodes;
        changed = true;
      }
      if (changed) script.textContent = JSON.stringify(data);
    }

    /**
     * Liste görünür oldu: ürün bilgisindeki puan rozeti(leri) bu bölüme bağlanır; sayfa
     * #kremi-reviews ile açıldıysa (rozet bağlantısı paylaşılmış / geri gelinmiş) şimdi kaydırılır —
     * ilk yüklemede blok gizli olduğu için tarayıcının kendi kaydırması boşa gitmişti.
     */
    function revealFromBadge() {
      if (!root.id) return;
      document.querySelectorAll('[data-kremi-rating-link]').forEach((a) => {
        a.setAttribute('href', '#' + root.id);
      });
      if (window.location.hash === '#' + root.id) {
        try {
          root.scrollIntoView({ block: 'start' });
        } catch (e) {
          /* eski tarayıcı: kaydırma yok, içerik yine görünür */
        }
      }
    }

    more.addEventListener('click', () => {
      loadPage().catch(() => {
        more.hidden = true;
      });
    });

    // ── Başlat: önce kapılar (sunucu), sonra veri ───────────────────────────
    getJson(BASE + '/config')
      .catch(() => ({}))
      .then((config) => {
        const listVisible = !!(config && config.listVisible);
        if (!listVisible) return; // metinler kapalı: blok tamamen sessiz, rozet bağlantısız kalır

        const summaries = Promise.all(
          products.map((p) =>
            getJson(BASE + '/summary?handle=' + encodeURIComponent(p.handle))
              .then((d) => (d && d.summary) || null)
              .catch(() => null),
          ),
        ).then(combineSummaries);

        buildChips();
        const initial = groupOfVariant(cfg.initialVariantId);
        const firstList = initial ? selectGroup(initial, true) : loadPage();

        return Promise.all([summaries, firstList]).then(([summary]) => {
          if (summary) renderSummary(summary);
          if (!summary && !list.childElementCount) return; // hiç yorum yok → blok gizli kalır
          root.hidden = false;
          if (isProduct) revealFromBadge();
          injectStructuredData(summary, firstPageReviews);
        });
      })
      .catch(() => {
        /* App Proxy hazır değil → blok gizli kalır (boş kutu yok) */
      });

    // Ürün sayfasında varyant değişince liste o varyanta geçer (yorumu yoksa "tümü" kalır).
    if (isProduct && groupOrder.length > 1) {
      document.addEventListener('variant:change', (event) => {
        const v = event.detail && event.detail.variant;
        const key = groupOfVariant(v && v.id);
        if (!key || root.hidden || !chipsEl || chipsEl.hidden) return;
        selectGroup(key, true).catch(showLoadError); // Tümü de düştüyse boş liste yerine hata metni
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-kremi-reviews]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Tema düzenleyicisinde bölüm yeniden yüklenince.
  document.addEventListener('shopify:section:load', boot);
})();
